<script lang="ts">
import {VTextField, VLabel} from 'vuetify/lib';

import {Component, Mixins, Prop} from 'vue-property-decorator';
import {VInput, VSwitch} from 'vuetify/lib/components';

//import {mask} from 'vue-the-mask';
import {VNode, VNodeData} from 'vue';

@Component({
  props: {
    labelLeft: String,
    labelRight: String,
    flat: {
      type: Boolean,
      default: true
    },
    hideDetails: {
      type: Boolean,
      default: true
    },

  }
})
export default class NSwitch extends Mixins(VSwitch) {
  labelLeft!: string;
  labelRight!: string;

  declare inputValue: boolean;
  declare hasState: any;
  declare isDisabled: any;

  public mounted() {
  }

  public genDefaultSlot(): (VNode | null)[] {
    return [
      (this as any).genLabel1('labelRight', this.labelRight),
      (this as any).genSwitch(),
      (this as any).genLabel1('labelLeft', this.labelLeft),
      (this as any).genLabel(),


    ];
  }

  genLabel1(inputKey: string, input: string) {
    if (!(this as any)[inputKey]) {
      return null;
    }
    return this.$createElement('div', {
      staticClass: 'side-label ' +
          inputKey + ' ' +
          (this.isDisabled ? 'disabled ' : ' ') +
          (this.hasState ? 'focused ' : ' ') +
          (this.inputValue && inputKey === 'labelLeft' ? 'active ' : ' ') +
          (!this.inputValue && inputKey === 'labelRight' ? 'active ' : ' '),
    }, this.$slots[inputKey] || input);
  }

}
</script>
<style lang="scss" scoped>
.v-input--selection-controls__input {
  margin-left: 8px;
  margin-right: 8px;
  height: 22px !important;
}

.v-input--selection-controls__ripple {
  display: none;

}

    .theme--light.v-input--switch .v-input--switch__thumb {
        color: var(--layout-primary-color);
    }

.v-input--switch__track.theme--light {
  color: rgba(0, 0, 0, 0.38) !important;
  top: calc(50% - 2px) !important;
  height: 6px !important;
  width: 30px !important;
}

.v-input--switch__thumb {
  top: calc(50% - 5px) !important;
  width: 12px !important;
  height: 12px !important;

}

.side-label {
  font-size: 14px;
  transition: color 0.3s;
  cursor: pointer;
  color: rgba(0, 0, 0, 0.87);

  &.active {
    color: var(--v-primary-base) !important;
    caret-color: var(--v-primary-base) !important;
  }
}

</style>
